var App = App || {};

App.ComponentTabs = (function ($) {
    'use strict';

    function init() {

        $(".component-tabs").each(function () {

            const component = $(this);
            const select = component.find(".component-tabs-tabs .component-tabs-tabs-dropdown .form-select");
            const tabPanes = component.find(".component-tabs-tabs .tab-pane");

            select.on("change", function () {
                const activeTab = component.find(`[data-bs-target=\"${$(this).val()}\"]`);
                activeTab.tab("show");
            });

            component.on("shown.bs.tab", function (e) {
                const activeTab = component.find("[data-bs-toggle=\"tab\"].active").attr("data-bs-target");
                select.val(activeTab);
            });

            component.find("[data-bs-toggle=\"tab\"]").first().tab("show");
            tabPanes.addClass("fade");
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.ComponentTabs.init();
});